<template>
  <div v-if="orderData.remarkList">
    <div class="order-solution">
      <div class="os-list">
        <div class="os-title">
          <el-row :gutter="24">
            <el-col :span="12">
              <div class="left flex-between">
                <div
                  class="title-control flex-between"
                  @click="showHandleData = !showHandleData"
                >
                  <i class="el-icon-arrow-up" v-if="!showHandleData"></i>
                  <i class="el-icon-arrow-down" v-else></i>
                </div>
                <p class="title">
                  {{ $lange == "en" ? "Remark" : "备注" }}
                </p>
                <span></span>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="right flex-between">
                <el-button
                  type="primary"
                  size="mini"
                  style="width: 150px"
                  @click="addRemark = true"
                  >{{ $lange == "en" ? "Add Remark" : "添加备注" }}</el-button
                >
              </div>
            </el-col>
          </el-row>
        </div>
        <el-collapse-transition>
          <div class="li_wrap" v-if="showHandleData">
            <div class="null_remark" v-if="orderData.remarkList.length == 0">
              无数据
            </div>
            <div
              class="li"
              v-for="(li, index) in orderData.remarkList"
              :key="index"
            >
              <!-- 手动添加备注 -->
              <el-alert type="info" :closable="false" v-if="li.objType == 0">
                <template v-slot:title>
                  <div class="title_wrap">
                    <h3 class="title">{{ li.createTime }}</h3>
                    <h3 class="title">{{ li.handlerName }}</h3>
                    <h3 class="title">添加备注</h3>
                  </div>
                </template>
                <template>
                  <div class="remark_wrap">
                    <div v-html="li.remark">{{ li.remark }}</div>
                  </div>
                </template>
              </el-alert>

              <!--  修改解决方案 -->
              <el-alert type="info" :closable="false" v-if="li.objType == 1">
                <template v-slot:title>
                  <div class="title_wrap">
                    <h3 class="title">{{ li.createTime }}</h3>
                    <h3 class="title">{{ li.handlerName }}</h3>
                    <h3 class="title">修改解决方案</h3>
                  </div>
                </template>
                <template>
                  <div class="remark_wrap">
                    <div class="li_data">
                      <div style="width: 200px">
                        {{ $lange == "en" ? "请求状态" : "请求状态" }}：{{
                          disposeStatus[li.extraData.status].label
                        }}
                      </div>
                    </div>
                    <div class="li_data">
                      <div style="width: 100px">
                        {{ $lange == "en" ? "Priority" : "优先级" }}：{{
                          li.extraData.priority
                        }}
                      </div>
                      <div style="width: 170px">
                        {{ $lange == "en" ? "Request Type" : "请求类型" }}：{{
                          ["一般咨询", "配件申请", "问题故障"][
                            li.extraData.requestType
                          ]
                        }}
                      </div>
                      <div
                        style="width: 200px"
                        v-if="
                          li.extraData &&
                          li.extraData.malfunctionId &&
                          li.extraData.malfunctionAttribute &&
                          li.extraData.requestType == 2
                        "
                      >
                        {{
                          $lange == "en" ? "Fault classification" : "故障分类"
                        }}：{{ li.extraData.malfunctionAttribute.name }}
                      </div>
                      <div
                        style="width: 200px"
                        v-if="
                          li.extraData &&
                          li.extraData.problemId &&
                          li.extraData.problemAttribute &&
                          li.extraData.requestType == 2
                        "
                      >
                        {{
                          $lange == "en" ? " Source of the issue" : " 问题来源"
                        }}：{{ li.extraData.problemAttribute.name }}
                      </div>
                    </div>
                    <div style="display: flex">
                      <div>解决方案：</div>
                      <div v-html="li.remark"></div>
                    </div>
                  </div>
                </template>
              </el-alert>

              <!--向客户推送处理方案--->
              <el-alert type="info" :closable="false" v-if="li.objType == 2">
                <template v-slot:title>
                  <div class="title_wrap">
                    <h3 class="title">{{ li.createTime }}</h3>
                    <h3 class="title">{{ li.handlerName }}</h3>
                    <h3 class="title">推送解决方案</h3>
                  </div>
                </template>
                <template>
                  <div class="remark_wrap">
                    <div v-html="li.remark">{{ li.remark }}</div>
                  </div>
                </template>
              </el-alert>

              <!--客户补充问题描述（点击【未解决】）--->
              <el-alert type="info" :closable="false" v-if="li.objType == 3">
                <template v-slot:title>
                  <div class="title_wrap">
                    <h3 class="title">{{ li.createTime }}</h3>
                    <h3 class="title">客户</h3>
                    <h3 class="title">问题未解决，提交补充描述</h3>
                  </div>
                </template>
                <template>
                  <div class="remark_wrap">
                    <div v-html="li.remark">{{ li.remark }}</div>
                  </div>
                </template>
              </el-alert>

              <!-- 取消服务请求--->
              <el-alert type="info" :closable="false" v-if="li.objType == 4">
                <template v-slot:title>
                  <div class="title_wrap">
                    <h3 class="title">{{ li.createTime }}</h3>
                    <h3 class="title">客户</h3>
                    <h3 class="title">取消服务请求</h3>
                  </div>
                </template>
                <template>
                  <div class="remark_wrap">
                    <div v-html="li.remark">{{ li.remark }}</div>
                  </div>
                </template>
              </el-alert>

              <!--配件--->
              <el-alert type="info" :closable="false" v-if="li.objType == 5">
                <template v-slot:title>
                  <div class="title_wrap">
                    <h3 class="title">{{ li.createTime }}</h3>
                    <h3 class="title">{{ li.handlerName }}</h3>
                    <h3 class="title">申请配件</h3>
                  </div>
                </template>

                <template>
                  <div class="remark_wrap">
                    <div
                      class="li_data"
                      v-for="(goods, ind) in li.extraData"
                      :key="ind"
                    >
                      <div style="width: 200px">
                        {{ $lange == "en" ? "FAS Code" : "FAS料号" }}：{{
                          goods.parts.fasCode
                        }}
                      </div>
                      <div style="width: 200px">
                        {{ $lange == "en" ? "FAS Na" : "物料名称" }}：{{
                          goods.parts.partsName
                        }}
                      </div>
                      <div style="width: 150px">
                        {{ $lange == "en" ? "Quantity" : "申请数量" }}：{{
                          goods.partsNum
                        }}
                      </div>
                      <div :style="$lange == 'en' ?'width: 150px': 'width: 100px'">
                        {{ $lange == "en" ? "Warehouse" : "仓库" }}：{{
                          wareAddress[goods.wareAddress]
                        }}
                      </div>
                      <div style="width: 115px" v-if="$lange != 'en'">
                        {{ $lange == "en" ? "Cost Type" : "费用类型" }}：{{
                          feeType[goods.feeType]
                        }}
                      </div>
                      <div style="width: 115px" v-if="$lange == 'en'">
                        {{ $lange == "en" ? "Cost Type" : "费用类型" }}：{{
                          feeType2[goods.feeType]
                        }}
                      </div>
                    </div>
                  </div>
                </template>
              </el-alert>

              <!--外派工单--->
              <el-alert type="info" :closable="false" v-if="li.objType == 6">
                <template v-slot:title>
                  <div class="title_wrap">
                    <h3 class="title">{{ li.createTime }}</h3>
                    <h3 class="title">{{ li.handlerName }}</h3>
                    <h3 class="title">申请外派</h3>
                  </div>
                </template>

                <template>
                  <div
                    class="remark_wrap"
                    v-if="li.extraData && li.extraData.expatriatePlanList"
                  >
                    <div
                      class="li_data"
                      v-for="(goods, ind) in li.extraData.expatriatePlanList"
                      :key="ind"
                    >
                      <div style="width: 200px" v-if="$lange != 'en'">
                        {{
                          $lange == "en" ? "Engineer Category" : "工程师类别"
                        }}：{{ employeeType[goods.employeeType] }}
                      </div>
                      <div style="width: 200px" v-if="$lange == 'en'">
                        {{
                          $lange == "en" ? "Engineer Category" : "工程师类别"
                        }}：{{ employeeType2[goods.employeeType] }}
                      </div>
                      <div style="min-width: 100px">
                        {{ $lange == "en" ? "Number of engineer" : "人数" }}：{{
                          goods.num
                        }}
                      </div>
                      <div style="min-width: 120px">
                        {{
                          $lange == "en"
                            ? "Estimated Working Hours"
                            : "预计总工时"
                        }}：{{ goods.preWorkHour }}
                      </div>
                      <div style="width: 130px" v-if="$lange != 'en'">
                        {{ $lange == "en" ? "Cost Type" : "费用类型" }}：{{
                          feeType[li.extraData.feeType]
                        }}
                      </div>
                      <div style="width: 130px" v-if="$lange == 'en'">
                        {{ $lange == "en" ? "Cost Type" : "费用类型" }}：{{
                          feeType2[li.extraData.feeType]
                        }}
                      </div>
                    </div>
                    <!-- <div>
                      计划开始时间：{{ getTime(li.extraData.startTime) }}
                    </div>
                    <div>计划结束时间：{{ getTime(li.extraData.endTime) }}</div> -->
                    <div class="time">
                      <span
                        :style="
                          $lange == 'en' ? 'width: 200px' : 'width: 200px'
                        "
                        >{{ $lange == 'en' ? 'Scheduled to start' : '计划开始时间'}}：{{
                          getTime(li.extraData.startTime)
                        }}</span
                      >
                      {{ $lange == 'en' ? 'Scheduled to finish' : '计划结束时间'}}：{{ getTime(li.extraData.endTime) }}
                    </div>
                  </div>
                </template>
              </el-alert>
            </div>
          </div>
        </el-collapse-transition>
      </div>
    </div>

    <el-dialog
      :title="$lange == 'en' ? 'Add remark' : '添加备注'"
      :visible.sync="addRemark"
      width="50%"
      append-to-body
    >
      <el-input
        size="mini"
        type="textarea"
        :rows="4"
        v-model="remarkMsg"
        :placeholder="$lange == 'en' ? 'Please enter remark' : '请输入备注'"
      ></el-input>
      <div class="add_remark_button">
        <!-- <el-button size="small" @click="addRemark = false">{{
          $lange == "en" ? "Cancel" : "取消"
        }}</el-button> -->

        <el-button type="primary" size="small" @click="saveRemark">{{
          $lange == "en" ? "Submit" : "保存"
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";

export default {
  props: {
    orderData: Object,
  },
  data() {
    return {
      showHandleData: true,
      addRemark: false,
      remarType: [
        "手动添加",
        "修改解决方案",
        "推送解决方案",
        "客户提交描述",
        "取消服务请求",
      ],
      remarkMsg: "",
      attributeData: {},
      disposeStatus: [
        {
          label: "申请中",
          value: 0,
        },
        {
          label: "处理中",
          value: 1,
        },
        {
          label: "观察中",
          value: 2,
        },
        {
          label: "已完成",
          value: 3,
        },
        {
          label: "已关闭",
          value: 4,
        },
        {
          label: "已取消",
          value: 5,
        },
      ],
      wareAddress: {
        fsWarehouse: "佛山",
        tjWarehouse: "天津",
        shWarehouse: "上海",
        cdWarehouse: "成都",
        consignmentSale: "寄售",
      },
      feeType: ["保内", "保外"],
      feeType2: ["Free", "Paid"],
      employeeType: ["机械工程师", "电气工程师", "软件工程师", "质量工程师"],
      employeeType2: ["Mechanic", "Electrical", "Software", "Quality"],
    };
  },
  methods: {
    getTime(e) {
      if (e) {
        return moment(e).format("YYYY-MM-DD");
      }
    },
    saveRemark() {
      let remarkMsg = this.remarkMsg.replace(/(^\s*)|(\s*$)/g, "");
      if (remarkMsg == "") {
        this.$message.error("请输入备注");
        return false;
      }
      let data = {
        remark: this.remarkMsg,
        workOrderId: this.orderData.id,
      };
      this.ccRequest
        .do("admin/fsb/work/order/addRemark", data, "GET")
        .then((res) => {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.remarkMsg = "";
          this.addRemark = false;
          this.$emit("updateOrder", ["remarkList", "isHandle"]);
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
    getData() {
      this.ccRequest
        .do(
          "admin/fsb/work/order/attribute/query?code=0&pageSize=999&isAsc=true&type=" +
            (this.$lange == "en" ? "1" : "0"),
          {},
          "GET"
        )
        .then((res) => {
          let attributeData = { ...this.attributeData };
          for (let index = 0; index < res.rows.length; index++) {
            attributeData[res.rows[index].id] = res.rows[index].name;
          }
          this.attributeData = attributeData;
        })
        .catch((err) => {
          console.log(err);
          this.$message.error(err.response.data.message);
        });

      this.ccRequest
        .do(
          "admin/fsb/work/order/attribute/query?code=1&pageSize=999&isAsc=true&type=" +
            (this.$lange == "en" ? "1" : "0"),
          {},
          "GET"
        )
        .then((res) => {
          let attributeData = { ...this.attributeData };
          for (let index = 0; index < res.rows.length; index++) {
            attributeData[res.rows[index].id] = res.rows[index].name;
          }
          this.attributeData = attributeData;
        })
        .catch((err) => {
          this.$message.error(err.response.data.message);
        });
    },
  },
  mounted() {
    // this.getData();
  },
};
</script>
<style scoped lang="scss">
.order-solution {
  background: #ffffff;
  margin-top: 5px;

  .os-list {
    padding: 20px;
    border-bottom: 1px dotted #ccc;
    // border-top: 5px solid #f3f3f4;
    .os-title {
      .left {
        justify-content: flex-start;

        > * {
          margin-left: 80px;
        }

        .title-control {
          padding: 0px;
          border-radius: 5px;
          border: 1px solid #e4e4e4;
          width: 24px;
          height: 24px;
          justify-content: center;
          font-size: 20px;
          cursor: pointer;
          margin-left: 0;
          & ~ .title {
            font-weight: bolder;
            color: #6f6f6f;
            width: 200px;
          }
        }

        .title {
          font-size: 18px;
          margin-left: 20px;
        }
      }
    }
  }
}
.li_wrap {
  margin-top: 20px;
  .li {
    margin-bottom: 20px;
  }
}
.remark_wrap {
  font-size: 14px;
  color: #000 !important;
}
.right {
  display: flex;
  // justify-content: end;
  justify-content: flex-end;
}
.add_remark_button {
  margin-top: 15px;
  display: flex;
  justify-content: center;
}
.title_wrap {
  display: flex;
  color: #000;
  padding: 10px 0;
  font-size: 12px !important;
  .title {
    margin-right: 10px;
    // font-size: 16px;
  }
}
.null_remark {
  text-align: center;
  padding: 10px;
  color: #c3c1c1;
}
.li_data {
  display: flex;
  margin-bottom: 5px;
  // font-size: 16px;
  div {
    margin-right: 20px;
    margin-bottom: 5px;
  }
}
.allPrice {
  margin-top: 10px;
  margin-bottom: 10px;
}
.time {
  display: flex;
  span {
    display: block;
    margin-right: 19px;
  }
}
</style>